module.exports = __webpack_public_path__ + "static/media/shoppingCart.4d5fb30f.svg";